import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["filename"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import isPropValid from '@emotion/is-prop-valid';
import { borderRadius } from '@infl-ts/ui-advocate-theme';
import { convertToSupportedLang } from '@infl-ts/util-date';
import { generateRandomFilename } from '@infl-ts/util-generate-random-filename';
import { useLanguage } from '@infl-ts/util-i18n-provider';
import { logError } from '@infl-ts/util-query-errors';
import { resolveNextViteImage } from '@infl-ts/util-resolve-next-vite-image';
import { Box, css, styled } from '@mui/material';
import { Filestack, PickerDisplayMode } from 'filestack-js';
import { absurd } from 'fp-ts/function';
import { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { fileTypeExt, imageTypeExt, imageTypes, uniqTypesFromExts, videoTypeExt, videoTypes } from './file-type-white-list';
import addPictureIcon from './images/addPicture.svg';
import fileIcon from './images/file.svg';
import videoCameraIcon from './images/videoCamera.svg';
import { SOURCE_ERROR } from './upload-from-capture';
import { jsx as _jsx } from "react/jsx-runtime";

var dropPaneReducer = function dropPaneReducer(state, action) {
  switch (action.type) {
    case 'initialize':
      return _objectSpread(_objectSpread({}, state), {}, {
        initialized: true
      });

    case 'fileUploading':
      return _objectSpread(_objectSpread({}, state), {}, {
        uploadedFile: null,
        hasError: false,
        tempFileName: action.value
      });

    case 'uploadFile':
      return _objectSpread(_objectSpread({}, state), {}, {
        uploadedFile: action.value,
        hasError: false,
        tempFileName: null
      });

    case 'showError':
      return _objectSpread(_objectSpread({}, state), {}, {
        hasError: action.value
      });

    case 'initPicker':
      return _objectSpread(_objectSpread({}, state), {}, {
        picker: action.value
      });

    default:
      return state;
  }
};

var DropPaneContainer = styled(Box, {
  shouldForwardProp: isPropValid
})(function (_ref) {
  var _theme$typography$bod, _theme$typography$bod2;

  var t = _ref.t,
      hasError = _ref.hasError,
      theme = _ref.theme,
      _ref$customTexts = _ref.customTexts,
      fileExtentionsText = _ref$customTexts.fileExtentionsText,
      dropZoneText = _ref$customTexts.dropZoneText,
      filename = _ref$customTexts.filename,
      acceptedMediaType = _ref.acceptedMediaType;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    cursor: ", ";\n    position: relative;\n    width: 100%;\n    word-wrap: break-word;\n    & .fsp-drop-pane__container {\n      padding: ", ";\n      background-color: ", ";\n      border-radius: ", ";\n      border: 1px dashed ", ";\n    }\n    & .fsp-drop-pane__icon {\n      background-image: url(", ");\n    }\n    .fsp-drop-pane__text {\n      width: 100%;\n      &::after {\n        display: block;\n        color: ", ";\n        content: '", "';\n      }\n    }\n    & .fsp-drop-pane__icon + .fsp-drop-pane__text {\n      max-width: 40ch;\n      font-size: ", ";\n      color: ", ";\n      text-align: center;\n      &::before {\n        content: '", "';\n        display: block;\n      }\n      &::after {\n        color: ", ";\n        content: '", "';\n      }\n    }\n\n    & .fsp-drop-pane__container:focus-within {\n      border: 2px solid ", ";\n      border-radius: ", ";\n    }\n    & .fsp-drop-pane__container {\n      pointer-events: ", ";\n    }\n    & .fsp-drop-pane__drop-zone,\n    .fsp-drop-pane__container,\n    .fsp-drop-pane__icon,\n    .fsp-drop-pane__input {\n      cursor: ", ";\n    }\n  "])), filename ? 'initial' : 'pointer', theme.spacing(7, 1, 7, 1), theme.palette.primary.contrastText, borderRadius(theme), hasError ? theme.palette.error.main : theme.palette.secondary.dark, resolveNextViteImage(acceptedMediaType === 'video' ? videoCameraIcon : acceptedMediaType === 'image' ? addPictureIcon : fileIcon), hasError ? theme.palette.error.main : theme.palette.secondary.contrastText, t('Uploading {{filename}}', {
    filename: filename
  }), (_theme$typography$bod = (_theme$typography$bod2 = theme.typography.body1.fontSize) === null || _theme$typography$bod2 === void 0 ? void 0 : _theme$typography$bod2.toString()) !== null && _theme$typography$bod !== void 0 ? _theme$typography$bod : 'inherit', hasError ? theme.palette.error.main : theme.palette.secondary.contrastText, dropZoneText, hasError ? theme.palette.error.main : theme.palette.secondary.dark, fileExtentionsText, theme.palette.primary.main, borderRadius(theme), filename ? 'none !important' : 'initial', filename ? 'initial' : 'pointer');
});

var isFile = function isFile(obj) {
  return obj !== null && obj.name !== undefined;
};

export var originalFileName = function originalFileName(metadata) {
  return isFile(metadata === null || metadata === void 0 ? void 0 : metadata.originalFile) ? metadata.originalFile.name : metadata.filename;
};
export var FileDropPane = function FileDropPane(_ref2) {
  var _infl, _state$tempFileName;

  var apiKey = _ref2.apiKey,
      pickerOptions = _ref2.pickerOptions,
      clientOptions = _ref2.clientOptions,
      storeParams = _ref2.storeParams,
      onSuccess = _ref2.onSuccess,
      onError = _ref2.onError,
      error = _ref2.error,
      questionId = _ref2.questionId,
      acceptedMediaType = _ref2.acceptedMediaType;

  var _useReducer = useReducer(dropPaneReducer, {
    initialized: false,
    picker: null,
    hasError: error,
    uploadedFile: null,
    tempFileName: null
  }),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang;

  var enabledExtensions = (_infl = window._infl) === null || _infl === void 0 ? void 0 : _infl.enabledExtensionsForFileUpload;
  var acceptedFileTypes = acceptedMediaType === 'video' ? videoTypes : acceptedMediaType === 'image' ? imageTypes : acceptedMediaType === 'file' ? uniqTypesFromExts(enabledExtensions || fileTypeExt) : absurd(acceptedMediaType);
  var acceptedFileExtensions = acceptedMediaType === 'video' ? videoTypeExt : acceptedMediaType === 'image' ? imageTypeExt : acceptedMediaType === 'file' ? enabledExtensions || fileTypeExt : absurd(acceptedMediaType);
  useEffect(function () {
    dispatch({
      type: 'showError',
      value: error
    });
  }, [error]);

  var onUploadCompleted = function onUploadCompleted(uploadedFile) {
    if (uploadedFile) {
      var _file = _objectSpread(_objectSpread({}, uploadedFile), {}, {
        mediaType: acceptedMediaType,
        filename: originalFileName(uploadedFile)
      });

      dispatch({
        type: 'uploadFile',
        value: _file
      });
      onSuccess(_file);
    } else {
      dispatch({
        type: 'showError',
        value: true
      });
      onError(t('Failed to upload file'));
    }
  };

  var containerId = "filestack-picker-container-".concat(questionId);
  useEffect(function () {
    var picker = Filestack(apiKey, clientOptions).picker({
      rootId: "#".concat(containerId, "-root"),
      container: "#".concat(containerId),
      maxFiles: 1,
      accept: acceptedFileTypes,
      onFileSelected: function onFileSelected(_ref3) {
        var filename = _ref3.filename,
            file = _objectWithoutProperties(_ref3, _excluded);

        return Promise.resolve(_objectSpread(_objectSpread({}, file), {}, {
          filename: generateRandomFilename(filename)
        }));
      },
      onFileUploadFinished: function onFileUploadFinished(file) {
        return onUploadCompleted(file);
      },
      onFileUploadFailed: function onFileUploadFailed(_, error) {
        if (error.message === SOURCE_ERROR) return;
        dispatch({
          type: 'showError',
          value: true
        });
        onError(error.message);
      },
      onUploadStarted: function onUploadStarted(files) {
        return dispatch({
          type: 'fileUploading',
          value: originalFileName(files[0])
        });
      },
      storeTo: storeParams,
      displayMode: PickerDisplayMode.dropPane,
      lang: convertToSupportedLang(currentLang),
      customText: _objectSpread({
        'Drag and Drop, Copy and Paste Files': ' '
      }, pickerOptions === null || pickerOptions === void 0 ? void 0 : pickerOptions.customText)
    });
    dispatch({
      type: 'initPicker',
      value: picker
    });
    return function () {
      void picker.close()["catch"](function (error) {
        logError(error);
        dispatch({
          type: 'showError',
          value: true
        });
        onError(typeof error === 'string' ? t(error) : t("There's been a problem closing the file picker"));
      });
    };
  }, []);
  useEffect(function () {
    if (!state.picker) return;

    if (state.uploadedFile) {
      void state.picker.close()["catch"](function (error) {
        logError(error);
        dispatch({
          type: 'showError',
          value: true
        });
        onError(typeof error === 'string' ? t(error) : t("There's been a problem closing the file picker"));
      });
      return;
    }

    if (!state.initialized) {
      dispatch({
        type: 'initialize'
      });
      void state.picker.open()["catch"](function (error) {
        logError(error);
        dispatch({
          type: 'showError',
          value: true
        });
        onError(typeof error === 'string' ? t(error) : t("There's been a problem opening up the file picker"));
      });
    }
  }, [state.uploadedFile, state.initialized, state.picker, t]);
  return /*#__PURE__*/_jsx(DropPaneContainer, {
    acceptedMediaType: acceptedMediaType,
    customTexts: {
      dropZoneText: t('Drop your {{acceptedMediaType}} here, or browse: ', {
        acceptedMediaType: t(acceptedMediaType)
      }),
      fileExtentionsText: acceptedFileExtensions.join(', '),
      filename: (_state$tempFileName = state.tempFileName) !== null && _state$tempFileName !== void 0 ? _state$tempFileName : ''
    },
    t: t,
    hasError: state.hasError,
    id: containerId,
    "data-element": "DropPaneContainer",
    "data-component": "FileDropPane",
    "data-source-file": "file-drop-pane.tsx"
  });
};